import PrjSearch from './PrjSearch.jsx';

export default () => {
    return {
        path: '/PrjSearch',
        element: <PrjSearch />,
    }
}